import { Theme } from "../../constants";
import { DataUtils } from "../../utils";
import { DefaultThemeData } from "./defaultTheme";
import { MrgThemeData } from "./mrGreenTheme";
import { PokerThemeData } from "./pokerTheme";
import { SIThemeData } from "./siTheme";

export class StyledComponentThemeProvider {
  static Provide = () => {
    const themeData = DataUtils.getDataStoreValue("ThemeData");

    const theme = themeData?.Theme || "default";

    switch (theme) {
      case Theme.Default: {
        return DefaultThemeData;
      }
      case Theme.SportsIllustrated: {
        return SIThemeData;
      }
      case Theme.Poker: {
        return PokerThemeData;
      }
      case Theme.MrGreen: {
        return MrgThemeData;
      }
    }
  };
}
